import { render, staticRenderFns } from "./contract-notes.vue?vue&type=template&id=7fdc191e&scoped=true&"
import script from "./contract-notes.vue?vue&type=script&lang=js&"
export * from "./contract-notes.vue?vue&type=script&lang=js&"
import style0 from "./contract-notes.vue?vue&type=style&index=0&id=7fdc191e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdc191e",
  null
  
)

component.options.__file = "contract-notes.vue"
export default component.exports